import { useContext, useEffect, useMemo, useState } from 'react';
import ReactModal from 'react-modal';
import { useNavigate } from 'react-router';
import { IoIosClose } from 'react-icons/io';

import Button from 'components/ui/button';
import { ModalContext } from 'context/ModalContext';
import { getStorageItem, setStorageItem } from 'utils/storage';

interface IProps {
  tasks: any[] | undefined;
}

export function TasksPendingApprovalParticipantsModal({ tasks }: IProps) {
  const navigate = useNavigate();

  const modalID = 'tasks-pending-approval-participants-modal';

  const { openModal, closeModal } = useContext(ModalContext);
  const [modalIsOpen, setIsOpen] = useState(false);

  ReactModal.setAppElement('#modal');

  function handleCloseModal() {
    //
  }

  function afterOpenModal() {
    //
  }

  function saveReadNotification() {
    const storedItem = getStorageItem('participant_notifications_read');
    let newStoredItem = [];

    if (Array.isArray(storedItem) && storedItem.length) {
      newStoredItem = [...storedItem, ...(tasks as any[]).map(x => x._id)];
    } else {
      newStoredItem = (tasks as any[]).map(x => x._id);
    }

    setStorageItem('participant_notifications_read', newStoredItem);
  }

  useEffect(() => {
    setIsOpen(openModal === modalID && !!tasks?.length);
  }, [openModal, tasks]);

  if (!Array.isArray(tasks) || !tasks?.length) {
    return <></>;
  }

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Example Modal"
        portalClassName="relative z-50"
        overlayClassName="fixed z-100 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center"
        contentElement={() => (
          <div>
            <div className="bg-oxford-blue relative ring-2 ring-electric-blue text-white rounded-xl py-8 px-16 block space-y-8 max-w-[576px]">
              <Button
                color="primary"
                className="absolute -right-5 -top-5  rounded-r-full rounded-l-full w-10 h-10 p-0 flex justify-center items-center"
                onClick={() => [saveReadNotification(), closeModal()]}
              >
                <IoIosClose color="white" size={30} />
              </Button>

              <h2 className="text-yellow text-lg block text-center !m-0 tracking-tight">
                Autorização de participação em Realização Destaque
              </h2>
              <p className="m-0 p-0 text-base block font-thin tracking-tight">
                O seu prefixo tem <strong>Realização Destaque com mais de 20 participantes pendente</strong> de autorização.
              </p>
              <p className="m-0 p-0 text-base block font-thin tracking-tight">
                OBS.: Caso queira autorizar a participação depois, basta acessar a página{' '}
                <strong>Minha equipe {'>'} Avaliar número de participantes em realização</strong>. Lá você encontrará o card da
                realização sinalizado pelo status e pronto para autorizar ou recusar a quantidade de participantes na realização.
              </p>
              <div className="flex justify-center">
                <Button
                  className="!py-2 !px-3 !text-sm !uppercase !leading-none"
                  onClick={() => [saveReadNotification(), navigate('/minha-equipe/participantes-da-realizacao')]}
                >
                  VER REALIZAÇÃO
                </Button>
              </div>
            </div>
          </div>
        )}
      />
    </>
  );
}
